// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { createTheme } from '@mui/material';
import cantonHeader from '../assets/cantonHeader.png';
import digitalAssetLogo from '../assets/digitalAssetLogo.png';
import { Branding } from '../utils/branding';
import baseline from './baseline';

const style = {
  filter: 'invert(1)',
  WebkitFilter: 'invert(1)',
};

const utilies: Branding = {
  loginLogo: <img alt="" src={cantonHeader} height="32px" style={style} />,
  headerLogo: <img alt="" src={cantonHeader} height="16px" style={style} />,
  companyLogo: (
    <img alt="" src={digitalAssetLogo} height="18px" style={{ display: 'inline-block' }} />
  ),
};

export default { branding: utilies, theme: createTheme(baseline) };
